import type {Law} from './types';
import {BESTAND} from '../content/bestand';
import {RID,RMAP} from '../content/ressorts';
import {GROUPS} from '../content/axes';
import {OUTLETS} from '../content/parties';
import {revertLaw} from './court';
import {press} from './media';

import {S,log} from './state';
import {clamp,de} from './util';


export function addBestand(){
  if(S.laws.some((L)=>L.bestand))return;
  BESTAND.forEach((x:any,k:any)=>S.laws.push({id:9000+k,bestand:true,left:0,t:x.t,d:x.d,r:'Finanzen',br:x.br||0,iss:null,stage:'done',leg:-1,
    fx:{b:x.b,g:x.g,pos:x.pos,sev:0,cut:0},rep2:x.rep||{}}));
}
export function repealFx(O?:any){const f=O.fx,neg=(o:any)=>Object.fromEntries(Object.entries<any>(o||{}).map(([k,v])=>[k,-v]));
  const pos=Object.fromEntries(Object.entries<any>(f.pos||{}).map(([k,v])=>[k,clamp(-v,-2,2)]));
  return{months:1,b:-(f.b||0),sev:0,cut:0,g:Object.fromEntries(Object.entries<any>(f.g||{}).map(([k,v])=>[k,v>0?-v*1.3:-v])),gr:-(f.gr||0),al:-(f.al||0),pos}}
export const repealable=(L:Law)=>L.stage==='done'&&!L.rep&&!S.laws.some((x:any)=>x.rep===L.id&&!['failed','blocked'].includes(x.stage));
export function startRepeal(id?:any){
  const O=S.laws.find((x:any)=>x.id===id);if(!O||!repealable(O))return;
  const L:any={id:S.nid++,rep:O.id,iss:null,t:`Aufhebung: ${O.t}`,r:'Finanzen',br:O.br||0,fx:repealFx(O),stage:'draft',left:1,p:{}};
  S.laws.push(L);S.tab='lage';log(`Das Finanzministerium bereitet die Aufhebung von „${O.t}“ vor.`);
}
export function applyRepeal(L?:any){
  const O=S.laws.find((x:any)=>x.id===L.rep);if(!O)return;const f=O.fx;
  revertLaw(O);O.stage='repealed';O.repM=S.m;S.suits=(S.suits||[]).filter((x:any)=>x.lid!==O.id);
  const hurt=Object.entries<any>(f.g||{}).filter(([,v])=>v>=1.5).map(([k])=>GROUPS[k]);
  log(`„${O.t}“ ist aufgehoben. Der Haushalt spart ${de(Math.max(0,-(f.b||0)))} Mrd € im Jahr.${hurt.length?` Verärgert: ${hurt.join(', ')}.`:''}`,'good');
  press(OUTLETS[hurt.length?3:1].n,hurt.length?`Kahlschlag: Regierung streicht „${O.t}“`:`Regierung räumt auf: „${O.t}“ gestrichen`,hurt.length?-.8:.3);
}

RID.wi.r.push('Landwirtschaft');RMAP['Landwirtschaft']='wi';
RID.wi.iss.push('insolvenz','agrar','preise');RID.ge.iss.push('aerzte');RID.in.iss.push('cyber');RID.bf.iss.push('kinderarmut');RID.dg.iss.push('ki');RID.vk.iss.push('laendlich');

